import {ReactData} from "./FrontendDataTypes";

export const employeeNeedsToChooseStandInForToday = (data: ReactData) : boolean => {
    return !data.employee_sick_today &&
        data.is_employee_client_sick_today &&
        data?.stand_in_for_client_today === undefined
}

export const employeeNeedsToChooseStandInForNextDay = (data: ReactData) : boolean => {
    return !data.employee_sick_next_work_day &&
        data.is_employee_client_sick_next_work_day &&
        data?.stand_in_for_client_next_work_day === undefined
}

export const employeeNeedsToChooseStandIn = (data: ReactData) : boolean => {
    return employeeNeedsToChooseStandInForToday(data) || employeeNeedsToChooseStandInForNextDay(data);
}